/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';

@tagName('')
export default class Expansion extends Component {
  // External API
  row = null;

  toggleExpand() {
    throw new Error('toggleExpand method must be provided');
  }

  @action
  toggleExpandAction() {
    this.toggleExpand();
  }
}
